const steps = [
  {
    icon: 'ri-upload-cloud-2-line',
    step: '01',
    title: '사진 업로드',
    desc: '본인 사진 2~3장을 업로드해주세요. 셀카, 일상 사진 모두 가능합니다.',
  },
  {
    icon: 'ri-palette-line',
    step: '02',
    title: '스타일 선택',
    desc: '야외 정원, 스튜디오, 해외 로케이션 등 원하는 배경과 스타일을 선택하세요.',
  },
  {
    icon: 'ri-magic-line',
    step: '03',
    title: 'AI 분석 & 생성',
    desc: '최첨단 AI가 얼굴 특징을 분석하고 웨딩 스냅 사진을 생성합니다.',
  },
  {
    icon: 'ri-download-cloud-2-line',
    step: '04',
    title: '결과물 수령',
    desc: '고화질 웨딩 스냅 사진을 당일 내로 다운로드하실 수 있습니다.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-28 bg-[#FDFAF6]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-[#C9A96E] text-xs tracking-[0.4em] uppercase mb-4 font-light">How It Works</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-[#2D2D2D] mb-5">
            단 4단계로 완성되는<br />
            <span className="italic">나만의 웨딩 사진</span>
          </h2>
          <p className="text-gray-500 text-sm font-light max-w-xl mx-auto leading-relaxed">
            복잡한 촬영 준비 없이, 집에서 편하게 웨딩 스냅 사진을 완성하세요.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s, i) => (
            <div key={s.step} className="relative group">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-[1px] bg-gradient-to-r from-[#C9A96E]/40 to-transparent z-0 -translate-x-4"></div>
              )}
              <div className="relative z-10 bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-[#F0E8DC] h-full flex flex-col">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#FDF5EA] shrink-0">
                    <i className={`${s.icon} text-2xl text-[#C9A96E]`}></i>
                  </div>
                  <span className="font-serif text-4xl font-light text-[#E8D5B7] leading-none">{s.step}</span>
                </div>
                <h3 className="font-serif text-lg font-medium text-[#2D2D2D] mb-3">{s.title}</h3>
                <p className="text-gray-500 text-sm font-light leading-relaxed flex-1">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
